/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Breadcrumb, BreadcrumbItem, ListGroup, ListGroupItem, Modal, ModalBody, ModalHeader } from "reactstrap";
import { faArrowRight } from "@fortawesome/pro-solid-svg-icons";
import { faHistory } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../../../reducers";


import { useRouteLayer } from "../../../../../hooks/useCurrentEntities";

const LocationTracker: React.FC = () => {
    const navigate = useNavigate();
    const browse_history = useSelector((state: RootState) => state.navigation.browse_history);
    const layer = useRouteLayer();

    const [isOpen, setModal] = useState(false);

    return (
        <>
            {browse_history.length > 0 && <div>
                <div>
                    <Breadcrumb className="d-none d-md-block" css={css` > ol { margin-bottom: 0 !important; }`}>
                        <BreadcrumbItem onClick={() => setModal(true)}>
                            <small className="text-muted cursor-pointer">
                                <FontAwesomeIcon icon={faHistory} /> Viewed items
                            </small>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </div>

                <Modal size="md" isOpen={isOpen} toggle={() => setModal(false)}>
                    <ModalHeader toggle={() => setModal(false)}>Previous viewed items</ModalHeader>

                    <ModalBody>
                        <ListGroup>
                            {removeDuplicates(browse_history).map((loc, index) => (
                                <ListGroupItem key={index} href="#" tag="button" onClick={() => navigate(`${loc.pathname}`)}>
                                    <div className="d-flex">
                                        <span>{loc?.text} {loc?.label}</span>

                                        {loc.id !== layer.id && (
                                            <span className="ms-auto">
                                                <FontAwesomeIcon icon={faArrowRight} />
                                            </span>
                                        )}
                                    </div>
                                </ListGroupItem>
                            ))}
                        </ListGroup>
                    </ModalBody>
                </Modal>
            </div>}
        </>
    );
};

export default LocationTracker;

function removeDuplicates(arrOfObjects: any[]) {
    const uniqueLabels: string[] = [];

    return arrOfObjects.reverse().filter((obj) => {
        if (!obj.label) {
            return false;
        }

        const isDuplicate = uniqueLabels.includes(obj.label);

        if (!isDuplicate) {
            uniqueLabels.push(obj.label);
            return true;
        }

        return false;
    }).reverse();
}
